import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {RecursosService} from './recursos.service';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import {AuthModel} from '../models/authModel';
import {AuthUserModel} from '../models/authUser';
import {StorageService} from './storage.service';
import {StorageKeys} from '../utils/constants/storageKeys';
import {ContextOptions} from '../models/context';
import {HttpContext} from '@angular/common/http';
import {NO_SEND_HEADER} from '../utils/constants/context';
import {Router} from '@angular/router';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private recursosService = inject(RecursosService);
  private configService = inject(ConfigService);
  private apiService = inject(ApiService);
  private storage = inject(StorageService);
  private router = inject(Router);

  auth: WritableSignal<any> = signal(null);
  user: WritableSignal<any> = signal(null);
  empleado: WritableSignal<any> = signal(null);

  constructor() {
    this.loadValuesFromStorage();
  }

  setAuthToLocalStorage(auth: any) {
    if (auth) {
      this.auth.set(auth);
      this.storage.set(StorageKeys.DATA, auth);
    }
  }

  setUserToLocalStorage(user: any) {
    if (user) {
      this.user.set(user);
      this.storage.set(StorageKeys.USER, user);
    }
  }

  setEmpleadoToLocalStorage(empleado: any) {
    if (empleado) {
      const empleadoToSave = {
        Id: empleado.Id,
        Nombre: empleado.Nombre,
        Codigo: empleado.Codigo,
        NroDoc: empleado.NroDoc,
        Sexo: empleado.Sexo,
        TipoDoc: empleado.TipoDoc,
        TipoEmpleado: empleado.TipoEmpleado
      };
      this.empleado.set(empleadoToSave);
      this.storage.set(StorageKeys.EMPLEADO, empleadoToSave);
    }
  }

  async loadValuesFromStorage() {
    const auth = await this.storage.get(StorageKeys.DATA);
    const user = await this.storage.get(StorageKeys.USER);
    const empleado = await this.storage.get(StorageKeys.EMPLEADO);

    if (auth) this.auth.set(auth);
    if (user) this.user.set(user);
    if (empleado) this.empleado.set(empleado);
  }

  login(data: any, context?: ContextOptions): Observable<AuthModel> {
    const url = `${this.configService.config().url_API_Sinergial}${this.recursosService.recursos.LOGIN.VERSION}${this.recursosService.recursos.LOGIN.PATH_BASE}`;
    let httpContext: any = {};
    if (context.header) {
      httpContext = new HttpContext().set(NO_SEND_HEADER, true);
    }
    return this.apiService.post<AuthModel>(
      url,
      data,
      httpContext as HttpContext
    );
  }

  logout() {
    this.storage.remove(StorageKeys.DATA);
    this.storage.remove(StorageKeys.USER);
    this.storage.remove(StorageKeys.EMPLEADO);
    this.auth.set(null);
    this.user.set(null);
    this.empleado.set(null);
    this.router.navigate(['/login']);
  }

  getUsuario(idUsr: number): Observable<AuthUserModel> {
    const url = `${this.configService.config().url_API_Sinergial}${this.recursosService.recursos.LOGIN.GET_USUARIO.VERSION}${this.recursosService.recursos.LOGIN.GET_USUARIO.PATH_REL.replace('{idUsuario}', idUsr)}`;
    return this.apiService.get<AuthUserModel>(url);
  }

  getEmpleado(idUsr: number): Observable<any> {
    const url = `${this.configService.config().url_API_Sinergial}${this.recursosService.recursos.EMPLEADO.VERSION}${this.recursosService.recursos.EMPLEADO.PATH_BASE}`;
    const params = {IdUsuario: idUsr};
    return this.apiService.get<any>(url, params);
  }
}
